<template>
    <div>
        <common-table :url="url"
                      :table-columns="tableColumns"
                      :form-fields="formFields"
                      :operate="operate"
                      :permission="permission"
                      :searchs="searchs"
                      :buttons="buttons"
                      :auto-update="true"
                      ref="table">
        </common-table>
        <div class="dialog">
            <el-dialog title="选择导出时间"
                       :visible.sync="exportVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm('form')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="form" ref="form">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
                            <el-select filterable
                                       v-model="form.agentId" clearable
                                       placeholder="请选择代理"
                                       size="medium" class="mr10 mb-10">
                                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.startTime"
                                            placeholder="开始时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.endTime"
                                            placeholder="结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="exportVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submit1('form')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <div class="dialog">
            <el-dialog title="批量再次转账"
                       :visible.sync="transferVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm('transferForm')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="transferForm" ref="transferForm">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
                            <el-select filterable
                                       v-model="transferForm.agentId" clearable
                                       placeholder="请选择代理"
                                       size="medium" class="mr10 mb-10">
                                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="transferForm.startTime"
                                            placeholder="开始时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="transferForm.endTime"
                                            placeholder="结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="transferVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitTransfer('transferForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

<!--        <div class="dialog">
            <el-dialog title="转账"
                       :visible.sync="tranVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm('tranForm')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="tranForm" ref="tranForm">
&lt;!&ndash;                        <el-form-item label="验证码:" prop="code" :rules="[{ required: true, message: '验证码不能为空', trigger: 'blur'}]">
                            <el-input v-model="tranForm.code" placeholder="请输入谷歌验证码"></el-input>
                        </el-form-item>

                        <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">
                            &lt;!&ndash;<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>&ndash;&gt;
                            <template>
                                <el-col :span="11" style="margin-right: 10px">
                                    <el-input v-model="tranForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                                </el-col>
                                <el-col :span="11">
                                    <el-button type="primary" @click="getCode('/system/getTgCode/withdrawalTransfer',60)" :disabled="btnCodeDisabled">{{codeName}}</el-button>
                                </el-col>
                            </template>
                        </el-form-item>&ndash;&gt;

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="tranVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submitTran('tranForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>-->
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import request from  "@/utils/axios.js";
    import message from "../../utils/message";
    //import {excelDownload} from "../../utils/download";

    export default {
        name: "Withdrawal",
        components: {CommonTable},
        data(){
            return{
                exportVisible: false,
                form: {
                    startTime: '',
                    endTime: '',
                    agentId: '',
                },
                codeName:'获取验证码',
                btnCodeDisabled: false,
                tranVisible: false,
                tranForm:{
                    id: '',
                    code: '',
                    tgCode: '',
                },
                transferVisible: false,
                transferForm: {
                    startTime: '',
                    endTime: '',
                    agentId: '',
                },
                agents: [],
                searchs:[
                    /*{
                        name: 'payeeName',
                        placeholder: '收款人姓名',
                        type: 'input'
                    },*/
                    {
                        name: 'agentId',
                        placeholder: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                    },
                    {
                        name: 'phone',
                        placeholder: '手机号',
                        type: 'input'
                    },
                    {
                        name: 'address',
                        placeholder: '提现地址',
                        type: 'input'
                    },
                    {
                        name: 'minAmount',
                        placeholder: '最小提现金额',
                        type: 'input'
                    },
                    {
                        name: 'maxAmount',
                        placeholder: '最大提现金额',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '失败'
                        },{
                            key: 1,
                            value: '成功'
                        },{
                            key: 2,
                            value: '审核中'
                        }]
                    },
                    {
                        name: 'transfer',
                        placeholder: '是否转账',
                        type: 'select',
                        selectValue:[{
                            key: 0,
                            value: '未转账'
                        },{
                            key: 1,
                            value: '已转账'
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'withdrawal:add',
                    update: 'withdrawal:update',
                    delete: 'withdrawal:delete',
                    deleteBatch: 'withdrawal:deleteBatch'
                },
                url: {
                    get: '/withdrawal/listByCondition',
                    //add: '/withdrawal/add',
                    //update: '/withdrawal/update',
                    //delete: '/withdrawal/delete/',
                    //delete_batch: '/withdrawal/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }/*,{
                    field: 'payeeName',
                    label: '收款人姓名',
                    show: true,
                    width: '',
                },{
                    field: 'cardNum',
                    label: '账号',
                    show: true,
                    width: '',
                }*/,{
                    field: 'amount',
                    label: '提现金额(USDT)',
                    show: true,
                    width: '',
                }/*,{
                    field: 'type',
                    label: '提现类型',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '银行卡',
                            type: 'success'
                        },{
                            key: 2,
                            value: '支付宝',
                            type: 'warning'
                        }]
                    },
                    width: '',
                }*/,{
                    field: 'type',
                    label: '提现来源',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '钱包',
                            type: 'primary'
                        },{
                            key: 2,
                            value: '推广',
                            type: 'warning'
                        }]
                    },
                    width: '',
                },{
                    field: 'address',
                    label: '提现地址',
                    show: true,
                    width: '',
                },{
                    field: 'txId',
                    label: '交易ID',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'failMsg',
                    label: '失败原因',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'rechargeNum',
                    label: '充值次数',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'rechargeMoney',
                    label: '充值总额',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'withdrawalNum',
                    label: '提现次数',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'withdrawalMoney',
                    label: '提现总额',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'ip',
                    label: '提现ip',
                    show: true,
                    width: '',
                },{
                    field: 'location',
                    label: '提现地区',
                    show: true,
                    width: '',
                }/*,{
                    field: 'detail',
                    label: '提现信息',
                    show: true,
                    width: '200px',
                }*/,{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '失败',
                            type: 'danger'
                        },{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 2,
                            value: '审核中',
                            type: 'info'
                        }]
                    },
                    width: '',
                },{
                    field: 'transfer',
                    label: '是否转账',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '未转账',
                            type: ''
                        },{
                            key: 1,
                            value: '已转账',
                            type: 'success'
                        }]
                    },
                    width: '',
                },{
                    field: 'confirmName',
                    label: '确认人',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '提现时间',
                    show: true,
                    width: '',
                },{
                  field: 'tradeFee',
                  label: '手续费',
                  show: true,
                  width: '',
                }],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    model: [{

                    }],
                },
                operate: [{
                    icon: 'el-icon-success',
                    type: 'text',
                    text: '成功',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/withdrawal/audit',
                            data: {id: row.id, status : 1},
                            confirm: '确定审核成功',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    },
                    exist: (row) => {
                        return row.status === 2 && this.$refs.table.havePermission('withdrawal:audit')
                    }
                },{
                    icon: 'el-icon-error',
                    type: 'text',
                    text: '失败',
                    handle: (row) => {
                        if (row.status != 2){
                            message.warning("已审核，不可重复审核");
                            return;
                        }
                        request.post({
                            url: '/withdrawal/audit',
                            data: {id: row.id, status : 0},
                            confirm: '确定审核失败？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("审核成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    },
                    exist: (row) => {
                        return row.status === 2 && this.$refs.table.havePermission('withdrawal:audit')
                    }
                },{
                    icon: 'el-icon-circle-check',
                    type: 'text',
                    text: '转账',
                    handle: (row) => {
                        if (row.status != 1){
                            message.warning("该状态不能转账");
                            return;
                        }
                        if (row.transfer == 1){
                            message.warning("改订单已转账");
                            return;
                        }
                        this.tranForm.id = row.id;
                        // this.tranVisible = true;
                      request.post({
                        url: '/withdrawal/transfer/' + this.tranForm.id /*+ "/" + this.tranForm.code + "/" + this.tranForm.tgCode*/,
                        data: {},
                        success: (data) => {
                          if (data.code == 0){
                            message.success("操作成功");
                            this.tranVisible = false;
                            this.$refs.table.getData();
                          }else {
                            message.error(data.msg || "操作失败");
                          }
                        }
                      });

                        /*this.$prompt('请输入验证码','提示',{
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(({value}) => {
                            if (!value) {
                                this.$message.warning("验证码不能为空");
                                return;
                            }
                            request.post({
                                url: '/withdrawal/transfer/' + row.id + "/" + value,
                                data: {},
                                success: (data) => {
                                    if (data.code == 0){
                                        message.success("操作成功");
                                        this.$refs.table.getData();
                                    }else {
                                        message.error("操作失败");
                                    }
                                }
                            });


                        }).catch(() => {
                            this.$message.info("取消");
                        });*/
                    },
                    exist: (row) => {
                        return row.status === 1 && row.transfer !== 1 && this.$refs.table.havePermission('withdrawal:transfer')
                    }
                },{
                    icon: 'el-icon-check',
                    type: 'text',
                    text: '转账成功',
                    handle: (row) => {
                        if (row.transfer === 1){
                            message.warning("已转账成功");
                            return;
                        }
                        request.post({
                            url: '/withdrawal/transferSuccess/' + row.id,
                            data: {},
                            confirm: '转账成功，系统不会进行转账（需手动转账），确定转账成功？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    },
                    exist: (row) => {
                        return row.transfer !== 1 && this.$refs.table.havePermission('withdrawal:transferSuccess')
                    }
                }],
                buttons: [{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '导出',
                    permission: 'withdrawal:export',
                    click: () => {
                        this.tableColumns.some(item => {
                            if (item.field == 'agentId') {
                                this.agents = item.selectData;
                            }
                        })
                        this.exportVisible = true;
                    }
                },{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '批量再次转账',
                    permission: 'withdrawal:batchWithdrawal',
                    click: () => {
                        this.tableColumns.some(item => {
                            if (item.field == 'agentId') {
                                this.agents = item.selectData;
                            }
                        })
                      request.post({
                        url: '/withdrawal/batchWithdrawal',
                        data: this.transferForm,
                        confirm: '确定批量转账？',
                        //responseType: 'arraybuffer',
                        success: (res) => {
                          if (res.code === 0) {
                            message.success("批量转账任务正在进行中");
                            this.transferVisible = false;
                          } else {
                            message.error(res.msg);
                          }
                        }
                      })
                    }
                },{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '修复提现统计数据',
                    permission: 'withdrawal:repair',
                    click: () => {

                        this.$prompt('请输入日期','提示',{
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(({value}) => {
                            if (!value) {
                                this.$message.warning("日期不能为空");
                                return;
                            }
                            request.post({
                                url: '/withdrawal/repair/' + value,
                                data: {},
                                confirm: '确定修复提现统计数据？',
                                //responseType: 'arraybuffer',
                                success: (res) => {
                                    if (res.code === 0) {
                                        message.success("数据统计修复成功");
                                    } else {
                                        message.error(res.msg);
                                    }
                                }
                            })

                        }).catch(() => {
                            this.$message.info("取消");
                        });
                    }
                }]
            }
        },
        methods: {

            /**
             * 获取验证码
             * @param url
             */
            getCode(url,second){
                if (!second) second = 60;
                this.codeName = second + "s后获取";
                this.btnCodeDisabled = true;
                request.get({
                    url: url,
                    data: {},
                })
                this.getCodeSeconds(second);

            },
            getCodeSeconds(second){
                setTimeout(()=>{
                    if (second > 1){
                        this.codeName = (second - 1) + "s后获取";
                        this.getCodeSeconds(second - 1);
                    }else {
                        this.btnCodeDisabled = false;
                        this.codeName = "获取验证码";
                    }
                },1000)
            },

            //重置表单
            resetForm(formName){
                this.$refs[formName].resetFields();
            },
            submit1(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        request.get({
                            url: '/withdrawal/export',
                            data: this.form,
                            confirm: '确定导出Excel？',
                            //responseType: 'arraybuffer',
                            success: (res) => {
                                if (res.code === 0) {
                                    message.success("提现导出任务正在进行中");
                                    this.exportVisible = false;
                                } else {
                                    message.error(res.msg);
                                }
                                /*if (res.code) {
                                    message.error(res.msg);
                                    return;
                                }
                                excelDownload(res, "提现明细导出.xlsx");
                                /!*this.$msgbox({
                                    title: '下载地址',
                                    message: '下载地址为：' + res.data + '，点击确定跳转下载！'
                                }).then(() => {
                                    window.open(res.data,"_blank");
                                }).catch()*!/

                                this.exportVisible = false;*/
                            }
                        })
                    }
                })
            },
            submitTransfer(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        request.post({
                            url: '/withdrawal/batchWithdrawal',
                            data: this.transferForm,
                            confirm: '确定批量转账？',
                            //responseType: 'arraybuffer',
                            success: (res) => {
                                if (res.code === 0) {
                                    message.success("批量转账任务正在进行中");
                                    this.transferVisible = false;
                                } else {
                                    message.error(res.msg);
                                }
                            }
                        })
                    }
                })
            },
            submitTran(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        /*if (!this.tranForm.code) {
                            this.$message.warning("验证码不能为空");
                            return;
                        }
                        if (!this.tranForm.tgCode) {
                            this.$message.warning("纸飞机验证码不能为空");
                            return;
                        }*/
                        request.post({
                            url: '/withdrawal/transfer/' + this.tranForm.id + "/" + this.tranForm.code + "/" + this.tranForm.tgCode,
                            data: {},
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.tranVisible = false;
                                    this.$refs.table.getData();
                                }else {
                                    message.error(data.msg || "操作失败");
                                }
                            }
                        });
                    }
                })
            }
            /*,
            submit() {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        request.get({
                            url: '/withdrawal/export',
                            data: this.form,
                            confirm: '确定导出Excel？',
                            responseType: 'arraybuffer',
                            success: (res) => {
                                if (res.code) {
                                    message.error(res.msg);
                                    return;
                                }
                                excelDownload(res, "提现明细导出.xlsx");
                                /!*this.$msgbox({
                                    title: '下载地址',
                                    message: '下载地址为：' + res.data + '，点击确定跳转下载！'
                                }).then(() => {
                                    window.open(res.data,"_blank");
                                }).catch()*!/

                                this.exportVisible = false;
                            }
                        })
                    }
                })
                // values可以从后端获取数据
                var values = ['aaa','bbb','ccc','ddd','eee']
                // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
                let str = ``
                // 增加\t为了不让表格显示科学计数法或者其他格式
                for (let i = 0; i < values.length; i++) {
                    str += values[i] + ','
                }
                str += '\n'
                // encodeURIComponent解决中文乱码
                let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
                // 通过创建a标签实现
                let link = document.createElement('a')
                link.href = uri
                // 对下载的文件命名
                link.download = 'tixian.csv'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }*/
        }
    }
</script>

<style scoped>

</style>
